import { Box } from '@factorialco/deprecated-design-system'

interface BulletListProps {
  items: string[]
}

const BulletList = ({ items }: BulletListProps) => {
  if (items.length === 0) return null

  return (
    <Box component="ul" gap="s4" padding="s16" style={{ listStyle: 'disc' }}>
      {items.map((item, index) => (
        <Box key={index} component="li" style={{ display: 'list-item' }}>
          {item}
        </Box>
      ))}
    </Box>
  )
}

export default BulletList
